export default "__VITE_PUBLIC_ASSET__a836ce87__"